import React, { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const Cookies = require("js-cookie");
  const cookieToken = Cookies.get("access_token");
  const lsToken = typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
  const token = cookieToken || lsToken;
  const location = useLocation();

  const userInfoString =
    typeof window !== "undefined" ? localStorage.getItem("user_info") : null;
  let userInfo: any = null;
  if (userInfoString) {
    try {
      userInfo = JSON.parse(userInfoString);
    } catch {
      userInfo = null;
    }
  }
  const role = userInfo?.role;

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (location.pathname.startsWith("/admin") && role === "USER") {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PrivateRoute;
